<template>
    <ul class="list-group message-list">
        <li class="list-group-item d-flex align-items-center"
            v-for="(item) of renderMsg"
            :key="item.msg_id"
            @click="selectContact(item.from, item.msg_id)"
            >
            <div>
              <div class="avatar">
                  <avatar :channel-id="item.channel_id"></avatar>
              </div>
            </div>
            <span class="contact-name">
                <div class="name-wrap">
                    <span>{{item.name}}</span>
                    <img class="channel-img" :src="item.channel_img" v-if="!!item.channel_img">
                </div>
                <div class="chat_time">{{item.time}}</div>
            </span>
            <div class="message-text" v-html="item.text"></div>
        </li>
    </ul>
</template>

<script>
import Avatar from "./avatar.vue";
import store from "store";

export default {
    components: {
      Avatar
    },
    props:{
        chatRecords:{
            type: Array,
            default(){
                return []
            }
        },
    },
    created(){
    },
    computed:{
        renderMsg() {
            return this.chatRecords.map((row) => {
                return {
                    ...row,
                    text: this.render(row),
                }
            })
        },
    },
    methods:{
        render(item){
            let html_start = `<span class="highlight">`
            let html_end = `</span>`
            if(!!item.search){
                let keywordStartIdx = item.text.indexOf(item.search);
                let keywordLength = item.search?.length;
                let textLength = item.text?.length;
                let reg = new RegExp( item.search, 'gi' );

                if(textLength < 50) {
                    let newText = item.text.replace( reg, html_start + item.search + html_end )
                    return newText;
                }
                
                if(keywordLength > 50){
                    let limitText = item.text.slice(keywordStartIdx, keywordStartIdx + 50)
                    let newText = `${html_start}${limitText}${html_end}...`
                    return newText;
                }

                if (textLength > 50) {
                    let limitText = item.text.slice(0, keywordStartIdx + 20)
                    if(keywordStartIdx > 20) { 
                        limitText = `...${item.text.slice(keywordStartIdx-10, keywordStartIdx + 20)}`
                    }
                    if(textLength > keywordStartIdx + 20){
                        limitText = `${limitText}...`
                    }
                    let newText = limitText.replace( reg, `${html_start}${item.search}${html_end}`)                        
                    return newText;
                }

                return item.text.replace( reg, `${html_start}${item.search}${html_end}`)   
            }

            return item.text;
        },
        selectContact(from_id, msg_id) {
            let from = this.renderMsg.find(v => {
                return v.from == from_id;
            });
            store.set("current-from", from);
            this.$router.push({
                name: "message",
                params: {
                    uid: from_id,
                    msg_id
                }
            });
        },
    }
}
</script>
